// The one door every cache READ goes through (CYBO-1846 B1). cacheInit opens it for the
// signed-in owner with a promise that settles once that owner's sign-in wipe is done; a read
// waits for it and serves a MISS when the wipe failed, the owner was not stored, or nobody
// is signed in. Fail-closed: the worst case is a cold network read.

let gate: { ready: Promise<boolean> } | null = null;

export function openReadGate(ready: Promise<boolean>): void {
  gate = { ready };
}

export function closeReadGate(): void {
  gate = null;
}

/** May a cache read serve rows right now? Waits for the current owner's wipe. */
export async function cacheReadable(): Promise<boolean> {
  const current = gate;
  if (!current) return false;
  const ok = await current.ready;
  // A sign-out or another sign-in while waiting: that answer is no longer this reader's.
  return ok && gate === current;
}
